import { Component } from '@angular/core';
import {
  InfoChipColor,
  InfoChipIconSet,
  InfoChipShape,
  InfoChipSize,
  InfoChipType,
} from '../../../common-components/info-chip/info-chip.types';

@Component({
  selector: 'app-info-chip-playground',
  templateUrl: './info-chip-playground.component.html',
  styleUrls: ['./info-chip-playground.component.scss'],
})
export class InfoChipPlaygroundComponent {
  label = 'Etiqueta';
  color: InfoChipColor = 'blue';
  type: InfoChipType = 'filled';
  size: InfoChipSize = 'large';
  shape: InfoChipShape = 'rounded-large';
  iconLeading = '';
  iconTrailing = '';
  iconSet: InfoChipIconSet = 'material-symbols-rounded';
  removable = false;

  removeCount = 0;

  onRemove(): void {
    this.removeCount += 1;
  }

  readonly colors = ['blue', 'green', 'red', 'gray', 'yellow'] as const;
  readonly types = ['filled', 'outline'] as const;
  readonly sizes = ['small', 'large'] as const;
  readonly shapes = ['rounded-small', 'rounded-large'] as const;
  readonly iconSets = ['material-symbols-rounded', 'material-icons', 'material-icons-outlined'] as const;
}
